import { apiFetch } from '../utils/api';

export interface DreamPriceProduct {
  id: number;
  product_id?: number;
  productId?: number;
  name?: string;
  price?: number;
}

export interface DreamPriceLocation {
  id: number;
  name?: string | null;
}

export interface DreamPrice {
  id: string;
  erpId: number;
  startDate: string | null;
  endDate: string | null;
  allowWalkInMember: boolean;
  allowRegisteredMember: boolean;
  allowEmployee: boolean;
  status: string | null;
  memberGroups: unknown[];
  employeeGroups: unknown[];
  products: DreamPriceProduct[];
  locations: DreamPriceLocation[];
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedDreamPricesResponse {
  data: DreamPrice[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

interface FetchDreamPricesParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const fetchDreamPrices = (
  params: FetchDreamPricesParams = {},
): Promise<PaginatedDreamPricesResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search);
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedDreamPricesResponse>(
    `/dream-prices${query ? `?${query}` : ''}`,
  );
};

export const fetchDreamPrice = (id: string) =>
  apiFetch<DreamPrice>(`/dream-prices/${id}`);
